import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { mergeMap, map } from 'rxjs/operators';
import { ForkJoinObservable } from 'rxjs/observable/ForkJoinObservable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/reduce';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/concat';
import 'rxjs/add/observable/forkJoin'

import { environment } from '../../environments/environment';
import { IS1Token } from '../models/IS1Token';
import { IQuota } from '../models/IQuota';
import { IQuestion } from '../models/IQuestion';
import { IQuotaTable } from '../models/IQuotaTable';
import { IS1Quota } from '../models/IS1Quota';
import { Item, IItem } from '../models/IItem';
import { ITextItem } from '../models/ITextItem';
import { IBillingEntity } from '../models/IBillingEntity';
import { ICurrency } from '../models/ICurrency';
import { ISupplier } from '../models/ISupplier';
import { ICategory } from '../models/ICategory';
import { Utils } from '../Utils';
import { IQuotaIRSampleSpec, IQuotaIRSampleSpecResults } from '../models/IQuotaIRSampleSpec';

@Injectable()
export class QuotaIRService {
  s1Token: IS1Token = null;
  genPopUrl: string;

  constructor(
    private http: HttpClient) {
    this.genPopUrl = environment.genPopUrl;
  }


  private getFezaHeaderAndOptions(correlationId: string = null) {
    return {
      headers: new HttpHeaders({ 'X-Correlation-ID': correlationId == null ? Utils.generateUUID() : correlationId })
    };
  }

  public GenPopIRWithUnsupportedVars(fastMode: boolean, specs: IQuotaIRSampleSpec): Observable<IQuotaIRSampleSpecResults> {
    return this.http.post<IQuotaIRSampleSpecResults>(this.genPopUrl + `/api/v1/genpop/incidencerate?fastCheck=${fastMode}`, specs, this.getFezaHeaderAndOptions(Utils.generateUUID()));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/genpop-quota-ir.service.ts